export const ADD_FAILED_PRINT = "ADD_FAILED_PRINT"
export const REMOVE_FAILED_PRINTS = "REMOVE_FAILED_PRINTS"
export const REMOVE_ALL_FAILED_PRINTS = "REMOVE_ALL_FAILED_PRINTS"